import { render, staticRenderFns } from "./StudentTuition.vue?vue&type=template&id=2c9d3661&scoped=true&"
import script from "./StudentTuition.vue?vue&type=script&lang=js&"
export * from "./StudentTuition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d3661",
  null
  
)

export default component.exports